import React from "react";
/* Components */
import ShaiaBot from "../components/shaiaBot/shaiabot";
import ChangePassForm from "../components/form/changePass";

const ChangePassword = () => {
  return (
    <div className="login-wrapper">
        <ShaiaBot />
        <ChangePassForm />
    </div>
  );
};

export default ChangePassword;
